import { createFileRoute } from "@tanstack/react-router";
import { ClientOnly } from "@/components/ClientOnly";
import { PageLoader } from "@/components/PageLoader";
import PageGate from "@/components/auth/PageGate";
import GameLobby from "@/pages/GameLobby";

export const Route = createFileRoute("/_app/games/$slug/")({
  component: () => (
    <PageGate pageKey="games"><ClientOnly fallback={<PageLoader />}><GameLobby /></ClientOnly></PageGate>
  ),
});
